/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, TouchableOpacity, type StyleProp, type TextStyle, type ViewStyle } from 'react-native';
import { ticketChrome } from './ticketChrome.styles';

export type TicketButtonVariant = 'ghost' | 'gold' | 'danger';

type Props = {
  label: string;
  onPress: () => void;
  variant?: TicketButtonVariant;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  accessibilityLabel?: string;
  testID?: string;
};

export function TicketButton({
  label,
  onPress,
  variant = 'ghost',
  disabled = false,
  style,
  textStyle,
  accessibilityLabel,
  testID,
}: Props) {
  const btnStyle =
    variant === 'gold'
      ? ticketChrome.btnGold
      : variant === 'danger'
        ? ticketChrome.btnDanger
        : ticketChrome.btnGhost;
  const labelStyle =
    variant === 'gold'
      ? ticketChrome.btnGoldText
      : variant === 'danger'
        ? ticketChrome.btnDangerText
        : ticketChrome.btnGhostText;

  return (
    <TouchableOpacity
      style={[btnStyle, disabled && { opacity: 0.45 }, style]}
      onPress={onPress}
      disabled={disabled}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel ?? label}
      accessibilityState={{ disabled }}
      testID={testID}
    >
      <Text style={[labelStyle, textStyle]}>{label}</Text>
    </TouchableOpacity>
  );
}
